export enum OrderScheduleStatus {
    NOT_PLACED = 0,
    DUE = 1,
    STARTED = 2,
    PLACED = 3,
    CONFIRMED = 4,
    CONFIRMED_ACK = 5,
    SHIPPED = 6,
    DELIVERED = 7,
}

